<script>
    import TextInput from "../atoms/TextInput.svelte";
    import NumberInputWithButton from "./NumberInputWithButton.svelte";

    export let onClick;
    export let nameValue;
    export let positionValue;
    export let maxValue;
    
    $:valid = nameValue !== "" && positionValue !== null;

</script>

<form>
    <TextInput bind:value="{nameValue}" text="Nom de la catégorie " id="cat"/>
    <NumberInputWithButton bind:positionValue={positionValue} valid={valid} maxValue={maxValue} onClick={onClick} />
</form>